var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case"},[_c('router-link',{attrs:{"to":("/case/" + _vm.slug)}},[_c('img',{attrs:{"src":_vm.img,"alt":""}})]),_c('div',{staticClass:"content"},[_c('p',{staticClass:"small_title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }